<template>
  <div>
    <base-header class="pb-5">
      <b-row aling-v="center" class="py-3">
        <b-col cols="7" lg="6">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block">
          </nav>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid="" class="mt--6 admin-menu">
      <div class="pb-1">
        <BaseButton id="blacklists.button.createblacklist" type="submit" class="btn bg-orange text-white "
          @click="onCreate">
          <span class="btn-inner--icon"><i class="ni ni-fat-add"></i></span>
          <strong>{{ translate('NEW BLACKLIST') }}</strong>
        </BaseButton>
      </div>
      <b-row>
        <b-col xl="12" class="order-xl-1 offset-xl-0">
          <!-- Table -->
          <BaseTable v-if="!isRetrievingBlacklists && blacklists.length" :items="blacklists" :columns="columns">
            <template #table-header-action>
              <div class="w-full flex justify-center mx-3 pt-4">
                <h3 id="blacklists.title.list">{{ translate('Blacklists') }}</h3>
              </div>
            </template>
            <template #actions="{ item }">
              <div class="flex items-center gap-x-2">
                <BaseButton id="blacklists.button.editItem"
                  :customClass="'rounded-circle border-none bg-blue-400 px-2 h-8 w-8'" @click="handleEdit(item.id)">
                  <el-tooltip :content="translate('Edit')" placement="top">
                    <i class="far fa-edit text-white text-xs"></i>
                  </el-tooltip>
                </BaseButton>

                <BaseButton id="blacklists.button.deleteItem"
                  :customClass="'rounded-circle border-none bg-red-500 px-2 h-8 w-8'" @click="onDelete(item.id)">
                  <el-tooltip :content="translate('Delete')" placement="top">
                    <i aria-hidden="true" class="fa fa-trash text-white text-xs"></i>
                  </el-tooltip>
                </BaseButton>
              </div>
            </template>
          </BaseTable>

          <!-- Loading State -->
          <div v-if="isRetrievingBlacklists" class="p-4 text-center h-96 grid place-items-center">
            <div class="text-center">
              <i class="fas fa-spinner fa-spin text-3xl"></i>
            </div>
          </div>

          <!-- No Data -->
          <div v-if="!isRetrievingBlacklists && !blacklists.length"
            class="p-4 text-center h-96 grid place-items-center">
            {{ translate('No Data Available') }}
          </div>
        </b-col>
      </b-row>
    </b-container>
    <blacklist-single-modal :blacklistSingle="singleBlacklist" :modalStatus="isOpen" :modalAction="actionModal"
      @close="onCloseSave" />
  </div>
</template>

<script>
import { translations } from '@/mixins';
import { Customer } from "@/services/SOLO";
import BaseTable from '@/components/Table/BaseTable.vue';
import BaseButton from '@/components/Buttons/BaseButton.vue';
import BlacklistSingleModal from '@/views/Admin/pages/Customers/v2/BlacklistSingleModal.vue';

export default {
  name: 'Blacklists',
  mixins: [translations],
  components: {
    BaseTable,
    BaseButton,
    BlacklistSingleModal
  },
  data() {
    return {
      blacklists: [],
      columns: [
        { label: 'ID', key: 'id', id: 'blacklists.column.id' },
        { label: 'Filter Type', key: 'attributes.type', id: 'blacklists.column.type' },
        { label: 'Value', key: 'attributes.value', id: 'blacklists.column.value' },
        { label: 'Created At', key: 'attributes.created-at', id: 'blacklists.column.createdAt' },
      ],
      isRetrievingBlacklists: true,
      page: 1,
      singleBlacklist: {},
      isOpen: false,
      actionModal: ''
    }
  },
  mounted() {
    this.getBlacklists(this.page);
  },
  methods: {
    async getBlacklists(page) {
      this.loading = true;
      let response = await Customer.getBlacklists(page);

      if (response?.data?.data && Array.isArray(response?.data?.data)) {
        this.blacklists = [...this.blacklists, ...response?.data?.data];
      }
      if (
        response.data.meta.pagination.current_page <
        response.data.meta.pagination.total_pages
      ) {
        this.getBlacklists(response.data.meta.pagination.current_page + 1);
      }
      this.isRetrievingBlacklists = false;
    },
    onCreate() {
      this.isOpen = true;
      this.actionModal = 'Create';
      this.singleBlacklist = null;
    },
    onCloseSave(action = 'close', response = null) {
      this.isOpen = false;
      this.singleBlacklist = response?.data?.data;

      switch (action) {
        case 'create':
          this.blacklists.unshift(response?.data?.data);
          break;
        case 'update':
          this.blacklists.forEach((element, index) => {
            if (element.id == response?.data?.data?.id) {
              element.attributes = response?.data?.data?.attributes;
            }
          });
          break;
      }
    },
    async handleEdit(id) {
      let response = await Customer.showBlacklist(id);
      this.singleBlacklist = response.data.data;
      this.isOpen = true;
      this.actionModal = 'Update';
    },
    async onDelete(id) {
      let confirm = await this.confirm(this.$bvModal, 'Are you sure to delete this blacklist?');

      if (confirm) {
        const notifyOptions = {
          title: 'DELETE DATA',
          verticalAlign: 'bottom',
          horizontalAlign: 'left',
          message: `Blacklist data was deleted successfully!`,
          type: 'success',
        };
        await Customer.deleteBlacklist(id);
        this.$notify(notifyOptions);
        this.blacklists.forEach((element, index) => {
          if (element.id == id) {
            this.blacklists.splice(index, 1)
          }
        });
      }
    },
    confirm(modalInstance, message) {
      return new Promise((resolve, reject) => {
        modalInstance.msgBoxConfirm(message, {
          title: 'Please Confirm',
          size: 'sm',
          buttonSize: 'md',
          okVariant: 'primary',
          okTitle: 'OK',
          cancelTitle: 'Cancel',
          footerClass: 'p-4',
          hideHeaderClose: false,
          centered: true
        }).then(value => {
          if (value) resolve(true)
          else reject(false)
        })
      })
    },
  },
}
</script>
